export enum EAdminEntitiesNavLabel {
  USER = 'Users',
  ZONE = 'Zones',
  LOGIN = 'Login Message', 
  ARTIST = 'Artists',
  PRODUCT_CHART_MATCH = 'Product Chart Matches',
  CHART_SOURCES = 'Chart Sources'
}

export const administrationEntitiesNav = [
  { label: EAdminEntitiesNavLabel.USER, value: '/admin/users' },
  { label: EAdminEntitiesNavLabel.ZONE, value: '/admin/labels' },
  { label: EAdminEntitiesNavLabel.LOGIN, value: '/admin/messages' },
  { label: EAdminEntitiesNavLabel.ARTIST, value: '/admin/artists' },
  { label: EAdminEntitiesNavLabel.PRODUCT_CHART_MATCH, value: '/admin/product-chart-match' },
  { label: EAdminEntitiesNavLabel.CHART_SOURCES, value: '/admin/chart-sources' },
]

export const mainEntitiesNav = [
  { label: 'Story Feed', value: '/feed' },
  { label: 'Projects', value: '/projects' },
  { label: 'Charts', value: '/charts' },
  { label: 'Products', value: '/products' },
  { label: 'Admin', value: '/admin/users' }
]
